import { useEffect, useState } from "react";
import ScalableWrapper from "@components/ScalableWrapper";
import View from "@components/View";
import "./StudioLogo.css";

const StudioLogo = () => {
  const [visible, setVisible] = useState(true);
  const [isFadeOut, setIsFadeOut] = useState(false);
  let timer: NodeJS.Timeout;

  useEffect(() => {
    document.addEventListener("appReadyEvent", (event) => {
      if (isFadeOut) {
        return;
      }

      setIsFadeOut(true);
      timer = setTimeout(() => {
        setVisible(false);
      }, 2000);
    });

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <View className={`splash-container ${visible ? "fade-in" : "fade-out"}`} enableEventCapturing>
      <ScalableWrapper ratio="16_9" maintainAspectRatioBy="height">
        <View className="logo-container">
          <img
            src="img/Logos/Studio_Logo.png"
            alt="Little Umbrella"
            className="logo"
          />
        </View>
      </ScalableWrapper>
      <ScalableWrapper ratio="16_9" anchor="bottom">
        <View className="support-logo-container">
          <img
            src="img/Logos/Powered_Playroom.png"
            alt="Little Umbrella"
            className="support-logo"
          />
        </View>
      </ScalableWrapper>
    </View>
  );
};

export default StudioLogo;
